const DetailPhotoBody = ({ imgURL, textValue, profileName }) => {
  return (
    <div className="flex items-center justify-center">
      <div className="modal-content-details shadow-sm dark:shadow-md w-fit flex items-center justify-center flex-col gap-4 p-4 rounded-md mb-3 bg-slate-200 dark:bg-primary-foreground ">
        <div className="profile full">
          {imgURL ? (
            <img
              src={imgURL}
              alt="Profile"
              className="rounded-full w-[6.5rem] h-[6.5rem] object-cover"
            />
          ) : (
            <span className="text-black">{textValue}</span>
          )}
        </div>
        <h5 className="text-foreground font-bold">{profileName}</h5>
      </div>
    </div>
  );
};

export default DetailPhotoBody;
